import React, { useState } from "react"
import { loadStripe } from "@stripe/stripe-js"

const Test = () => {
  const [email, setEmail] = useState("")
  const goToCheckout = (name: string) => {
    loadStripe("pk_test_9RLhRlcit0UN52GbxvCBvkjd").then((stripe) => {
      fetch("http://localhost:4000/v1/create-checkout-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
        }),
      }).then((data) => {
        data.json().then((x) => {
          console.log(x)
          stripe
            ?.redirectToCheckout({
              sessionId: x.sessionId,
            })
            .then((res) => {
              console.log(res)
            })
        })
      })
    })
  }

  return (
    <div>
      <input onChange={(e) => setEmail(e.currentTarget.value)} type="text" />
      <button onClick={() => goToCheckout("Basic")}>Basic</button>
      <button onClick={() => goToCheckout("Standard")}>Standard</button>
      <button onClick={() => goToCheckout("Expert")}>Expert</button>
    </div>
  )
}

export default Test
